"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var clsx_1 = tslib_1.__importDefault(require("clsx"));
exports.Label = function (_a) {
    var children = _a.children, required = _a.required, className = _a.className;
    return (react_1.default.createElement(StyledLabel, { className: clsx_1.default(className, 'label', { 'is-required': required }) }, children));
};
exports.Label.displayName = 'FOS_Label';
var StyledLabel = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  font-size: 1.3rem;\n  color: ", ";\n  font-family: ", ";\n  line-height: 2rem;\n  margin-bottom: 0.4rem;\n\n  &.is-required:after {\n    content: '*';\n    color: red;\n    margin-left: 0.4rem;\n  }\n"], ["\n  font-size: 1.3rem;\n  color: ", ";\n  font-family: ", ";\n  line-height: 2rem;\n  margin-bottom: 0.4rem;\n\n  &.is-required:after {\n    content: '*';\n    color: red;\n    margin-left: 0.4rem;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.NTDarkGrey[900];
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.robotoMedium;
});
var templateObject_1;
